
import React from 'react'
import '../../styles.scss';
import { useTranslation } from 'react-i18next';
import { PmrClassificationComponent } from '../../../../Util/PmrClassification/PmrClassification';
import { capitalizeFirstLetter } from '../../../../../services/stringUtil';

export const HeaderPmr = ({ data }) => {
  const { t } = useTranslation();

  return (
    <header className="c-title">
      <div className="summary-header">
        <h3 className='code-text'>{data.code}</h3>
        <h2 className='title-text'> {data.nameProject}</h2>
        <h3 className='code-text'>{capitalizeFirstLetter(t('loan'))}: {data.loanNumber}</h3>
      </div>

      <div className="summary-header text-align-right">
        <p>
          {t('one_pager_report.' + data.typeReport)}{' '}
          <span>{t('app_name')}</span>
        </p>

        <p style={{ fontSize: '0.8rem' }}>
          {t('one_pager_report.creation')}: {data.creationDate}
        </p>

        <div className='clasification-details'>
          <PmrClassificationComponent classificationColor={data.pmrClassification} />
          <h3>{data.pmrValue} {t('pmr')}</h3>
        </div>
      </div>
    </header>
  );
};
